export function checkForRewards(type) {
    // +++ SG 25.10.2018 (T18-14883):
    if (typeof shopUserId === 'undefined') {
        shopUserId = $('#search_data').data('user_id');
    }
    if (typeof company === 'undefined') {
        company = $('#search_data').data('company');
    }
    if (typeof shopCode === 'undefined') {
        shopCode = $('#search_data').data('shop_code');
    }
    if (typeof languageCode === 'undefined') {
        languageCode = $('#search_data').data('site_language');
    }
    if (typeof customerNo === 'undefined') {
        customerNo = $('#search_data').data('customer_no');
    }
    if (typeof mainLanguageId === 'undefined') {
        mainLanguageId = $('#search_data').data('site_language_id');
    }
    if (typeof mainLanguageCode === 'undefined') {
        mainLanguageCode = $('#search_data').data('site_language');
    }
    if (typeof siteCode === 'undefined') {
        siteCode = $('#search_data').data('site_code');
    }
    // --- SG 25.10.2018


    $.ajax({
        type: "POST",
        url: "/module/community/ajax.php?action=check_for_rewards",
        datatype: "json",
        data: {
            "ajax_call_type": type,
            "ajax_call_shop_user_id": shopUserId,
            "ajax_call_company": company,
            "ajax_call_shop_code": shopCode,
            "ajax_call_language_code": languageCode,
            "ajax_call_customer_no": customerNo,
            "ajax_call_main_language_id": mainLanguageId,
            "ajax_call_main_language_code": mainLanguageCode,
            "ajax_call_site_code": siteCode
        },
        success: function (output) {
            if (output !== "false") {
                var data = $.parseJSON(output);
                if ($("#success_modal_new_rewards").length) {
                    $("#success_modal_new_rewards").remove();
                }
                $("body").append(data.modal);
                $('#success_modal_new_rewards').modal("show");
                updatePointsInHeader();
            }
        }
    });
}